import { useState, useEffect } from 'react';

/**
 * Hook that returns a short "time ago" string (e.g. '4s', '2m', '3h', '1d') and
 * updates automatically over time.
 */
export default function useTimeAgo(isoTimestamp) {
  const [label, setLabel] = useState('');

  useEffect(() => {
  // If no timestamp is provided, reset label
    if (!isoTimestamp) {
      setLabel('');
      return;
    }

    const getLabel = () => {
      const then = new Date(isoTimestamp).getTime();
      const now = Date.now();
      const diff = Math.floor((now - then) / 1000); // seconds

      if (diff < 60) return `${diff}s`;
      if (diff < 3600) return `${Math.floor(diff / 60)}m`;
      if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
      return `${Math.floor(diff / 86400)}d`;
    };

    // initial
    setLabel(getLabel());

    // choose interval based on age: every 1s for <60s, every 60s for >=60s
    const tickInterval = () => {
      const then = new Date(isoTimestamp).getTime();
      const now = Date.now();
      const diff = Math.floor((now - then) / 1000);
      return diff < 60 ? 1000 : 60000;
    };

    let interval = tickInterval();
    const id = setInterval(() => {
      setLabel(getLabel());
      const newInterval = tickInterval();
      if (newInterval !== interval) {
        // restart interval with new frequency
        clearInterval(id);
      }
    }, interval);

    return () => clearInterval(id);
  }, [isoTimestamp]);

  return label;
}
